import { BaseApi } from './base.api.js';

export class RiskReportsApi extends BaseApi {
    constructor(client) {
        super(client, '/risk-reports');
    }
}
